export default __webpack_public_path__ + "assets/authBackground.99bf88770a9b0bf7a733c1fb2f5d83a8.jpg";